import React, { Component } from "react";
import { Helmet } from "react-helmet";
//import Footer from 'components/Footer/Footer';
//import './style.css';
//import PKimg from 'Assets/pksuccess.svg';
// import { Alert, Button } from 'react-bootstrap';
//import Button from "components/Button/Button";
//import Table from 'react-bootstrap/Table';
import AgoraVideoRoomComponent from 'components/AgoraVideoRoom/components/VideoRoomComponent';
import { user_access_level, apiUrl, user_entity_uuid, myHeaders_Auth_With_Cache_Control } from "Api/Api";
// , myHeaders_With_Cache_Control, user_API, user_Status, user_Status_Ver, presentation_Creation_API, searchUrl, org_friendly_url, organization_user_access_level, user_account_level,owner_perms, org_name,
import axios from "axios";
//import { getKey, dateConvert, unixDateConversion,origin, current_unix_stamp } from 'utils/Helper';
import { get_current_unix_stamp } from 'utils/Helper';
// getKey, dateConvert, unixDateConversion, 
import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner';
//import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
//import EmptyMessage from 'components/EmptyMessage/EmptyMessage';
//import PkList from 'components/PkListTable/PkList';
//import PkListTable from 'components/PkListTable/PkListTable';
//import PkListTableV2 from 'components/PkListTable/PkListTableV2';
//import VideoChat from 'components/VideoChat/VideoChat';
import { withRouter, Redirect } from "react-router-dom";
//import TableHeader from 'components/Table/TableHeaderV2';
//import home from 'Assets/home.svg';
// import { local_routes } from 'utils/Routes';

import UserContext from 'store/UserContext';

class AgoraVideoChat extends Component {
  static contextType = UserContext;
  constructor(props) {
      super(props)
      this.state = {
        loading: true,
        chat_info: {},
        //incall_flag: false,
        allowed: true,
        is_owner: false,
        current_chat_uuid: null,
        //openvidu_token: null,
        //openvidu_session_id: null,
        //openvidu_session_name: null
        agora_token: null,
        agora_ss_token: null,
        agora_rtm_token: null,
        
        //agora_session_id: null,
        //agora_session_name: null
      };
      this.chat_info_poll_interval = null;
  }

  // Api Integration Strats here
  APICalls = async function () {
    console.log("AgoraVideoChat APICalls");
    let chat_friendly_url = this.props.match.params.friendly_url.toLowerCase();
    
    // get chat info from friendly_url
    let chat_response = await axios.get(`${apiUrl}chats/${this.state.chat_info.entity_uuid || chat_friendly_url}`,myHeaders_Auth_With_Cache_Control);
    
    // is user allowed?
    let tmp_allowed = false;
    let tmp_is_owner = false;
    if (user_access_level === 'admin') {
      // yes
      tmp_allowed = true;
    }
    if (chat_response.data.shared_access_write_uuids && chat_response.data.shared_access_write_uuids.includes(user_entity_uuid)) {
      tmp_is_owner = true;
      tmp_allowed = true;
    }
    
    if (chat_response.data.chat_type && chat_response.data.chat_type === 'open_discussion') {
      tmp_allowed = true;
    } else if (chat_response.data.shared_access_read_uuids && chat_response.data.shared_access_read_uuids.includes(user_entity_uuid)) {
      tmp_allowed = true;
    }
    
    if (!tmp_allowed) {
      this.setState({ allowed: false });
      return;
    }

    if (JSON.stringify(this.state.chat_info) !== JSON.stringify(chat_response.data) || this.state.is_owner !== tmp_is_owner) {
      //console.log(" UPDATING");
      this.setState({
        chat_info: chat_response.data,
        is_owner: tmp_is_owner
      });
    }
    
    return chat_response.data;
  }
  
  componentDidMount = async function () {
    console.log("AgoraVideoChat componentDidMount");
    let chat_info = await this.APICalls();
    this.chat_info_poll_interval = setInterval(() => this.APICalls(), 5000);
    /*
    let chat_friendly_url = this.props.match.params.friendly_url.toLowerCase();
    
    // get chat info from friendly_url
    let chat_response = await axios.get(`${apiUrl}chats/${chat_friendly_url}`,myHeaders_Auth_With_Cache_Control);
    
    // is user allowed?
    let tmp_allowed = false;
    let tmp_is_owner = false;
    if (user_access_level === 'admin') {
      // yes
      tmp_allowed = true;
    }
    if (chat_response.data.shared_access_write_uuids && chat_response.data.shared_access_write_uuids.includes(user_entity_uuid)) {
      tmp_is_owner = true;
      tmp_allowed = true;
    }
    
    if (chat_response.data.chat_type && chat_response.data.chat_type === 'open_discussion') {
      tmp_allowed = true;
    } else if (chat_response.data.shared_access_read_uuids && chat_response.data.shared_access_read_uuids.includes(user_entity_uuid)) {
      tmp_allowed = true;
    }
    
    if (!tmp_allowed) {
      this.setState({ allowed: false });
      return;
    }

    this.setState({
      chat_info: chat_response.data,
      is_owner: tmp_is_owner
    });
    */

    await this.joinSession(chat_info);
  }
    
  componentWillUnmount = async () => {
    clearInterval(this.chat_info_poll_interval);
    //await this.leftCallCleanup();
  }
  
  leftCallCleanup = async (close_chat_flag = false) => {
    // update chats status with "left_time"
    //alert('wtf1');
    console.log("AgoraVideoChat leftCallCleanup",this.state.chat_info.entity_uuid,this.state.is_owner,close_chat_flag);

    /*
    if (chat_uuid) {
      let api_promises = [];
      let patch_obj = {
        left_time: get_current_unix_stamp()
      };
      api_promises.push(axios.patch(`${apiUrl}users/${user_entity_uuid}/chats/${chat_uuid}`,patch_obj));
      if (this.state.is_owner && close_chat_flag) {
        patch_obj = {
          status_code: 2
        };
        api_promises.push(axios.patch(`${apiUrl}chats/${chat_uuid}`,patch_obj));
      }
      await Promise.all(api_promises);
    }
    */
    
    // JBB 6/10/2021 FYI only one request is allowed when user closes window
    /*
    let patch_obj = {
      left_time: get_current_unix_stamp()
    };
    axios.patch(`${apiUrl}users/${user_entity_uuid}/chats/${chat_uuid}`,patch_obj);
    */
    
    if (this.state.is_owner && close_chat_flag) {
      // end chat forever!
      let patch_obj = {
        status_code: 2,
        end_time: get_current_unix_stamp()
      };
      await axios.patch(`${apiUrl}chats/${this.state.chat_info.entity_uuid}`,patch_obj);
    } else {
      // just leave
      let patch_obj = {
        left_time: get_current_unix_stamp()
      };
      await axios.patch(`${apiUrl}users/${user_entity_uuid}/chats/${this.state.chat_info.entity_uuid}`,patch_obj);
    }
    
    this.setState({
      //agora_session_id: '',
      //agora_session_name: '',
      agora_token: '',
      //current_chat_uuid: '',
      chat_info: {},
      loading: true
    });
    
    window.close('','_parent',''); // comment out for debugging
  }

  // called on mount to get agora tokens
  joinSession = async (chat_info) => {
    this.setState({
      button_loading: true,
      loading: true
    });
    
    // get token
    let get_token_response = await axios.post(`${apiUrl}chats/${chat_info.entity_uuid}/getAgoraToken`);
    
    this.setState({
      loading: false,
      //current_chat_uuid: chat_info.entity_uuid,
      agora_token: get_token_response.data.agora_token,
      agora_ss_token: get_token_response.data.agora_ss_token,
      agora_rtm_token: get_token_response.data.agora_rtm_token,
      //agora_session_id: chat_info.agora_session_id,
      //agora_session_name: chat_info.entity_name
    });
  }

  // called after agora connects in component
  handlerJoinSessionEvent = () => {
    console.log("JOINED via AGORA",this.state.chat_info.entity_uuid);
    
    //this.props.inCallCallback(true);
    
    let patch_obj = {
      joined_time: get_current_unix_stamp(),
      left_time: -1 // might erase previous join, but I think that is ok
    };
    axios.patch(`${apiUrl}users/${user_entity_uuid}/chats/${this.state.chat_info.entity_uuid}`,patch_obj);
  }

  handlerLeaveSessionEvent = (close_chat_flag = false) => {
    console.log("LEFT",close_chat_flag,this.state.chat_info.entity_uuid);
    clearInterval(this.chat_info_poll_interval);
    this.leftCallCleanup(close_chat_flag);
  }

  handlerErrorEvent = (event) => {
    console.error("ERROR",event);
  }
  
  transferOwnership = async (user_obj) => {
    console.log("transferOwnership",user_obj);
    let user_uuid;
    if (user_obj.entity_uuid) {
      user_uuid = user_obj.entity_uuid;
    } else if (user_obj.uid) {
      user_uuid = user_obj.uid;
    } else {
      // bail!
      return;
    }
    
    let remove_owner_patch_obj = {
      entity_owner_integer: -1,
      entity_reader_integer: 1
    };
    let add_owner_patch_obj = {
      entity_owner_integer: 1,
      entity_reader_integer: -1
    };
    await Promise.all([
      axios.patch(`${apiUrl}chats/${this.state.chat_info.entity_uuid}/users/${user_entity_uuid}`, remove_owner_patch_obj),
      axios.patch(`${apiUrl}chats/${this.state.chat_info.entity_uuid}/users/${user_uuid}`, add_owner_patch_obj)
    ]);
    let new_chat_results = await axios.get(`${apiUrl}chats/${this.state.chat_info.entity_uuid}`,myHeaders_Auth_With_Cache_Control);
    
    this.setState({
      chat_info: new_chat_results.data,
      is_owner: false
    });
  }
  
  onKicked = async () => {
    clearInterval(this.chat_info_poll_interval);
  }
  
  kickUser = async (user_obj) => {
    console.log("kickUser",user_obj);
    let user_uuid;
    if (user_obj.entity_uuid) {
      user_uuid = user_obj.entity_uuid;
    } else if (user_obj.uid) {
      user_uuid = user_obj.uid;
    } else {
      // bail!
      return;
    }
    
    let kick_user_patch_obj = {
      kicked_time: Math.floor(new Date().getTime() / 1000),
      entity_reader_integer: -1
    };

    await Promise.all([
      axios.patch(`${apiUrl}chats/${this.state.chat_info.entity_uuid}/users/${user_uuid}`, kick_user_patch_obj)
    ]);
    /*
    let new_chat_results = await axios.get(`${apiUrl}chats/${this.state.current_chat_uuid}`,myHeaders_Auth_With_Cache_Control);
    
    this.setState({
      chat_info: new_chat_results.data,
      is_owner: false
    })
    */
  }

  addInvitee = async (user_info) => {
    //clearInterval(this.interval);
    this.setState({
      button_loading: true
    });

    console.log("addInvitee",user_info,this.state.chat_info.entity_uuid);
    
    // now invite somebody to chat
    let post_obj = {
      invited_time: get_current_unix_stamp(),
      entity_reader_integer: 1,
      kicked_time: -1
    }
    let invite_chat_response = await axios.post(`${apiUrl}chats/${this.state.chat_info.entity_uuid}/users/${user_info.entity_uuid}`,post_obj);
    
    //await this.APICalls();
  }
  
  render() {
    if (!this.state.allowed) {
      return (
        <Redirect to="/404" />
      );
    }
    
    if (this.state.loading || !this.context.user_info.entity_uuid || !this.state.chat_info.entity_uuid) {
      return (
        <FullPageSpinner />
      );
    }
    
    /*
    if (!this.context.user_info.chats || !this.context.user_info.chats[this.state.current_chat_uuid]) {
      return (
        <React.Fragment>
          <Alert show={true} variant="warning">
            <Alert.Heading>This Chat Has Ended</Alert.Heading>
            <p>
              Please Close This Window
            </p>
            <hr />
            <div className="d-flex justify-content-end">
              <Button onClick={() => this.handlerLeaveSessionEvent} variant="outline-success">
                Close
              </Button>
            </div>
          </Alert>
        </React.Fragment>
      );
    }
    */
    
    let title_fragment = 'PechaKucha Video Chat';
    if (this.state.chat_info.chat_type === 'webinar') {
      title_fragment = 'PechaKucha Webinar';
    } else if (this.state.chat_info.chat_type === 'open discussion') {
      title_fragment = 'PechaKucha Open Discussion';
    }
    
    return (
      <React.Fragment>
        <Helmet>
            <title>{title_fragment} - {this.state.chat_info.entity_name}</title>
            <meta name="robots" content="noindex" />
        </Helmet>
        <React.Fragment>
            <AgoraVideoRoomComponent
              theme={this.context.theme}
              is_owner={this.state.is_owner}
              //id="opv-session"
              //sessionId={this.state.agora_session_id}
              //sessionName={this.state.agora_session_name}
              user_info={this.context.user_info}
              //user_uuid={user_entity_uuid}
              chat_info={this.context.user_info.chats[this.state.chat_info.entity_uuid] || {}}
              init_chat_info={this.state.chat_info}
              //chat_info={this.state.chat_info}
              //sessionId={this.state.chat_info.entity_uuid}
              //sessionName={this.state.chat_info.entity_name}
              //user={this.context.user_info.nickname}
              token={this.state.agora_token}
              ss_token={this.state.agora_ss_token}
              rtm_token={this.state.agora_rtm_token}
              joinSession={this.handlerJoinSessionEvent}
              leaveSession={this.handlerLeaveSessionEvent}
              error={this.handlerErrorEvent}
              transferOwnership={this.transferOwnership}
              kickUser={this.kickUser}
              onKicked={this.onKicked}
              onInviteUser={(user_info) => this.addInvitee(user_info)}
            />
        </React.Fragment>
      </React.Fragment>
    );
  }
}

export default withRouter(AgoraVideoChat);